import initMadeCategoryPrint from "components/jiffy/made-category-print/made-category-print";

document.addEventListener("DOMContentLoaded", () => {
  initMadeCategoryPrint();
});
